__turbopack_context__.v({
  "eyebrow": "PerformanceOptimizationServicesCardSection-module__dEGeWW__eyebrow",
  "heading": "PerformanceOptimizationServicesCardSection-module__dEGeWW__heading",
  "section": "PerformanceOptimizationServicesCardSection-module__dEGeWW__section",
  "title": "PerformanceOptimizationServicesCardSection-module__dEGeWW__title",
});
